<template>
  <div class="bg-white rounded-lg px-20 py-12 mb-6">
    <div class="flex justify-between items-center h-10">
      <div class="headline-sm text-gray-92">メールアドレス</div>
      <button
        class="border rounded text-gray-62 font-semibold hover:button focus:outline-none"
        style="width: 91px; height: 32px"
        @click="$emit('toggleEmailEditFormShow')"
      >
        キャンセル
      </button>
    </div>
    <div class="body-md text-gray-92 mt-4">
      新しいメールアドレスを入力し「認証メールを送る」ボタンを押してください。<br />
      届いたメールに記載のURLをクリックすると変更が完了します。
    </div>
    <Form v-slot="{ handleSubmit, meta, errors }">
      <form
        @submit="handleSubmit($event, handleSendMailClicked)"
        novalidate="novalidate"
      >
        <div class="mt-6">
          <div class="title-sm">現在のメールアドレス</div>
          <div class="body-md mt-2">{{ currentEmail }}</div>
        </div>
        <div class="mt-6">
          <div class="title-sm">新しいメールアドレス</div>
          <Field
            style="width: 440px"
            class="border rounded mt-2 h-10 px-4"
            name="email"
            type="email"
            v-model="email"
            :rules="validateEmail"
          />
          <ErrorMessage
            name="email"
            as="span"
            class="block text-danger text-xs leading-6"
          />
        </div>
        <button
          class="mt-4 px-4 py-2 rounded-lg text-white button-md bg-secondary-main"
          :class="{
            'bg-secondary-main':
              !isProcessing && meta.dirty && Object.keys(errors).length === 0,
            'hover:button':
              !isProcessing && meta.dirty && Object.keys(errors).length === 0,
            'bg-slate-300':
              isProcessing || !meta.dirty || Object.keys(errors).length > 0,
            'cursor-not-allowed':
              isProcessing || !meta.dirty || Object.keys(errors).length > 0,
          }"
          :disabled="
            isProcessing || !meta.dirty || Object.keys(errors).length > 0
          "
        >
          認証メールを送る
        </button>
      </form>
    </Form>
  </div>
</template>

<script>
import { ErrorMessage, Field, Form } from 'vee-validate';
import rules from '@/utils/validateRules.js';
import { inject, reactive, ref, toRefs } from 'vue';
import axios from '@/utils/axiosAuth.js';
import { useRouter } from 'vue-router';

export default {
  components: {
    Field,
    ErrorMessage,
    Form,
  },
  props: {
    currentEmail: {
      type: String,
      require: true,
    },
  },
  methods: {
    validateEmail(value) {
      const result = rules.validate(value, 'required|email');
      if (result !== true) return result;

      if (value === this.currentEmail) {
        return '既に登録されているメールアドレスです';
      }
      return true;
    },
  },
  setup() {
    const globalStore = inject('globalStore');
    const globalMethods = inject('globalMethods');
    const router = useRouter();

    const email = ref('');
    const state = reactive({
      isProcessing: false,
    });

    const handleSendMailClicked = (values, actions) => {
      state.isProcessing = true;
      const postData = {
        email: email.value,
      };
      axios
        .post(
          `sellers/${globalStore.seller.id}/email/update-verify-send`,
          postData
        )
        .then((response) => {
          if (!response.data.result) {
            actions.setFieldError('email', response.data.message);
            return;
          }
          router.push({
            name: 'AccountEmailVerifySendCompleted',
          });
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            '',
            e.callback
          );
          globalMethods.sendLog(e);
        })
        .finally(() => {
          state.isProcessing = false;
        });
    };

    return {
      ...toRefs(state),
      email,
      handleSendMailClicked,
    };
  },
};
</script>
